import { DrawerFilter, DrawerFilterType } from '../../../models';

export const createRolesFilters = (
  rolesForFilter: {
    text: string;
    value: string;
  }[]
): DrawerFilter[] => {
  return [
    {
      name: 'reportToID',
      label: 'Reports to',
      type: DrawerFilterType.SELECT,
      value: undefined,
      list: rolesForFilter,
    },
  ];
};
